export default __webpack_public_path__ + "static/media/self-serve.84b887b9.png";